export default __webpack_public_path__ + "static/media/NeedAGateDriver.bcac616b.svg";